export default class SubTaskParent {
    parse(data) {
        this.id = data.id;
        this.name = data.name;

        return this;
    }
}
